import { parse } from './parser'
import { MinidownNode, MinidownNodeType } from './nodes'

/**
 * Strips all Minidown from the source.
 *
 * @param source
 */
export function stripMinidown(source: string): string {
  return visit(parse(source))
}

/**
 * The visitor.
 */
function visit(node: MinidownNode): string {
  switch (node.type) {
    case MinidownNodeType.Text:
      return node.value
    case MinidownNodeType.Root:
    case MinidownNodeType.Emphasis:
    case MinidownNodeType.Strong: {
      return node.children.reduce((prev, next) => prev + visit(next), '')
    }
    /* istanbul ignore next: unreachable, but still. */
    default:
      return ''
  }
}
